import React from "react";
import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faCrown } from "@fortawesome/free-solid-svg-icons";

import consultingIcon from "images/tileIcons/consulting.svg";

import { TypeIcon, InfoItem, DeleteButton, Divider } from "components/Home/Utils/Utils";
import getStyles from "components/Home/Utils/getStyles";

import { PROGRESS_STAGES } from "containers/ConsultingProjects/reducer";
import { ProgressIcon } from "components/ConsultingProjects/ConsultingProjects";

import styles from "components/Tiles/style.module.css";
import utilStyles from "components/Home/Utils/utils.module.css";

const projectStyles = getStyles("project");

export default class ProjectTile extends React.PureComponent {
  handleDelete(event) {
    event.stopPropagation();
    const { handleDelete } = this.props;

    if (handleDelete) {
      return handleDelete();
    } else return;
  }

  render() {
    const { project, dataset, isCreate, isFirst, isHighlight, handleDelete, onClick, onHover, consultantActive } =
      this.props;

    if (isCreate || isFirst) {
      return <CreateProjectTile isFirst={isFirst} onClick={onClick} />;
    }

    if (!project) {
      return <React.Fragment></React.Fragment>;
    }

    const links = project && project.wizard && project.wizard.project && project.wizard.project.links;

    const status = project.wizard && project.wizard.project && project.wizard.project.status;

    const authorText = consultantActive
      ? project && project.wizard && project.wizard.project && project.wizard.project.commissioner
      : project.created_by.fullname;

    let linksArr = false;
    if (links) {
      linksArr = Object.keys(links)
        .map((key) => {
          return {
            type: key,
            num: links[key] ? links[key].length : 0
          };
        })
        .filter((elem) => elem.num > 0);
    }

    return (
      <div className={styles.tileWrapper}>
        <div
          className={(onClick ? styles.tile : styles.tileNoHover) + (isHighlight ? " " + styles.projectHighlight : "")}
          onClick={() => {
            if (onClick) {
              onHover && onHover(undefined);
              return onClick();
            } else return;
          }}
          onMouseEnter={onHover ? () => onHover(project.id) : () => {}}
          onMouseLeave={onHover ? () => onHover(undefined) : () => {}}
        >
          <div className={styles.tileActions}>
            {handleDelete ? <DeleteButton type={"blueprint"} clickHandler={(event) => this.handleDelete(event)} /> : ""}
          </div>
          <div className={styles.tileHeader + " " + projectStyles.background}>
            <h1 title={project.name} className={projectStyles.text}>
              {project.name}
            </h1>
            <p title={moment.utc(project.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}>
              {moment.utc(project.created_date).local().fromNow()}
            </p>
            <div className={styles.tileHeaderContent}>
              <div>
                <div className={utilStyles.hideMobile}>
                  <ProgressIcon status={status} colorClass={projectStyles.text} size={"34px"} margin={"0px"} />
                </div>
                {status ? (
                  <h1
                    style={{
                      textTransform: "capitalize",
                      margin: "0px"
                    }}
                    className={styles.createTileHeader + " " + projectStyles.text}
                  >
                    {status}
                  </h1>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className={styles.tileBody}>
            {project.created_by ? (
              <InfoItem
                icon={<FontAwesomeIcon icon={consultantActive ? faCrown : faUser} />}
                iconStyle={{ color: styles.aibleColor }}
                text={authorText}
              />
            ) : (
              ""
            )}
            {linksArr && linksArr.length > 0 ? (
              <div className={utilStyles.hideMobile + " " + styles["flex-column"]} style={{ width: "100%" }}>
                <Divider />
                <div className={styles["flex-row"]} style={{ width: "100%" }}>
                  {linksArr.map((elem, i) => (
                    <TypeIcon key={elem.type} border type={elem.type} num={elem.num} />
                  ))}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

export class CreateProjectTile extends React.PureComponent {
  render() {
    const { onClick, isFirst } = this.props;
    const text = isFirst ? "Projects" : "Create Consulting Offer";
    return (
      <div className={styles.tileWrapper}>
        <div className={onClick ? styles.tile : styles.tileNoHover} onClick={onClick ? () => onClick() : () => {}}>
          <div className={styles.tileHeader}>
            <div className={styles.createTileIcon}>
              <img src={consultingIcon} alt={text} />
            </div>
          </div>
          <div className={styles.tileBody}>
            <div className={styles.createTileHeader + " " + projectStyles.text}>{text}</div>
          </div>
        </div>
      </div>
    );
  }
}
